export const hasSubscriptionItems = (cartItems) => {
  if (!Array.isArray(cartItems)) return false;
  return cartItems.some((item) => item.subscription);
};